import Text from "./inputs/text";
import Email from "./inputs/email";
import Select from "./inputs/select";
import Submit from "./inputs/submit";
import CountryPhone from "./inputs/country_phone";
import Textarea from "./inputs/textarea";
import Tel from "./inputs/tel";
import React, { Component } from "react";
import Captcha from "./inputs/captcha";
import { emailSubjects } from "../solvar/contactUsHelper";

class ContactUsForm extends Component
{
    constructor(props)
    {
        super(props);

        this.defaultContryValue = (this.props.defaultCountry ?? '61');
        this.emailSubjects = Object.values(emailSubjects);

        this.state = {
            working: false,
            errorAlert: false,
            successAlert: false,
            disabled: false,
            fields: {
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                country: this.defaultContryValue, // Default to australia +61
                subject: "",
                message: "",
                captcha: ""
            },
            errors: {}
        };

        this.handleCloseClick  = this.handleCloseClick.bind(this);
        this.handleFormSubmit  = this.handleFormSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleValidation  = this.handleValidation.bind(this);
        this.handleCaptchaChange  = this.handleCaptchaChange.bind(this);
        this.resetCaptchaValue = this.resetCaptchaValue.bind(this);
    }

    resetCaptchaValue()
    {
        let fields = this.state.fields;

        fields['captcha'] = "";

        this.setState({
            fields: fields
        });
    }

    handleCaptchaChange(value)
    {
        let fields = this.state.fields;
        let errors = this.state.errors;

        if (value) {
            delete errors['captcha'];
        }

        fields['captcha'] = value;

        this.setState({
            fields: fields,
            errors: errors
        });
    }

    handleInputChange(event)
    {
        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        let fields = this.state.fields;
        let errors = this.state.errors;

        if (value) {
            delete errors[name];
        }

        fields[name] = value;

        this.setState({
            fields: fields,
            errors: errors
        });
    }

    handleCurrencyKeyPress(event)
    {
        event = event || window.event;
        var charCode = (typeof event.which == "undefined") ? event.keyCode : event.which;
        var charStr = String.fromCharCode(charCode);

        if (!/\d|\./.test(charStr)) {
            event.preventDefault();
            return;
        }

        if (
            /\./.test(charStr) &&
            this.state.loan_amount.match(/\./)
        ) {
            event.preventDefault();
            return;
        }
    }

    handleCloseClick()
    {
        this.setState({
            errorAlert: false,
        });
    }

    handleValidation()
    {
        const fields = this.state.fields;

        let isValid = true;

        let errors = {};

        for (const field in fields) {
            if (!fields[field]) {
                isValid = false;

                let revertedCamelCaseField = field.replace(
                    /(^[a-z]|[A-Z])/g, function (g) {
                        return " " + g[0].toUpperCase();
                    }
                );

                errors[field] = `${revertedCamelCaseField} is required.`;
            }
        }

        this.setState({
            errors: errors,
        });

        return isValid;
    }

    async handleFormSubmit(event)
    {
        event = event || window.event;
        event.preventDefault();

        let fields = this.state.fields;
        const isValidForm = this.handleValidation();

        if (!isValidForm) {
            return;
        }

        this.setState({
            working: true,
            errorAlert: false,
            successAlert: false,
        });

        const res = await fetch(
            "/api/email/contact-us",
            {
                body: JSON.stringify(fields),
                headers: {
                    "Content-Type": "application/json",
                },
                method: "POST",
            }
        );

        const { error } = await res.json();

        if (error) {
            this.setState({
                working: false,
                errorAlert: true
            });
            return;
        }

        for (const field in fields) {
            if (field == 'country') {
                fields[field] = this.defaultContryValue;
                continue;
            }
            fields[field] = "";
        }

        this.setState({
            working: false,
            fields: fields,
            successAlert: true,
        });
    }

    render()
    {
        const { working, errorAlert, successAlert, disabled, fields, errors } = this.state;
        const { firstName, lastName, email, phone, country, subject, message } = fields;

        let errorAlertContent;

        if (errorAlert) {
            errorAlertContent = (
                <div className="flex p-20 border-3 border-[red]/50 rounded mt-20 text-[red]">
                    <p className="grow">An error occured while attempting to send your message. Please try again.</p>
                    <p className="hover:underline cursor-pointer" onClick={ this.handleCloseClick }>X</p>
                </div>
            );
        }

        let successAlertContent;

        if (successAlert) {
            successAlertContent = (
                <div className="flex p-20 border-2 bg-bb rounded mt-20 text-white">
                    <p className="grow">Your message has been sent successfully.</p>
                </div>
            );
        }

        const emailSubjectOptions = this.emailSubjects.map((item, index) => {
            return (<option key={ index } value={ item }>{ item }</option>);
        });

        return (
            <form disabled={ disabled } onSubmit={ this.handleFormSubmit }>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-20">
                    <div>
                        <label className="block mb-5" htmlFor="firstName">First Name*</label>
                        <Text
                            error={ errors.firstName ?? false }
                            id="firstName"
                            maxLength="50"
                            name="firstName"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ firstName ?? "" }
                        />
                    </div>
                    <div>
                        <label className="block mb-5" htmlFor="lastName">Last Name*</label>
                        <Text
                            error={ errors.lastName ?? false }
                            id="lastName"
                            maxLength="50"
                            name="lastName"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ lastName ?? "" }
                        />
                    </div>
                    <div className="sm:col-span-2">
                        <label className="block mb-5" htmlFor="email">Email Address*</label>
                        <Email
                            error={ errors.email ?? false }
                            id="email"
                            maxLength="50"
                            name="email"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ email ?? "" }
                        />
                    </div>
                    <div>
                        <label className="block mb-5" htmlFor="country">Country*</label>
                        <CountryPhone
                            error={ errors.country ?? false }
                            id="country"
                            name="country"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ country ?? "" }
                        />
                    </div>
                    <div>
                        <label className="block mb-5" htmlFor="phone">Phone Number*</label>
                        <Tel
                            error={ errors.phone ?? false }
                            id="phone"
                            name="phone"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ phone ?? "" }
                        />
                    </div>
                    <div>
                        <label className="block mb-5" htmlFor="subject">Subject*</label>
                        <Select
                            error={ errors.subject ?? false }
                            id="subject"
                            name="subject"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ subject ?? "" }
                        >
                            <option value="">Select...</option>
                            { emailSubjectOptions }
                        </Select>
                    </div>
                    <div className="sm:col-span-2">
                        <label className="block mb-5" htmlFor="message">Message*</label>
                        <Textarea
                            className="min-h-[120px]"
                            error={ errors.message ?? false }
                            id="message"
                            maxLength="255"
                            name="message"
                            onChange={ this.handleInputChange }
                            required={ false }
                            value={ message }
                        />
                    </div>
                    <div>
                        <Captcha
                            onChange={ this.handleCaptchaChange }
                            onErrored={ this.resetCaptchaValue }
                            onExpired={ this.resetCaptchaValue }
                            error={ errors.captcha ?? false }
                        />
                    </div>
                    <div className="sm:col-span-2">
                        <Submit
                            disabled={ disabled }
                            value={ working ? "Please wait…" : "Send Message" }
                            working={ working }
                        />
                        { successAlertContent }
                        { errorAlertContent }
                    </div>
                </div>
            </form>
        )
    }
}

export default ContactUsForm;